import React, { useEffect } from 'react'
import styles from './Stats.module.scss'
import ReactGA from 'react-ga4';

const Stats = () => {
    useEffect(() => {
        try {
            ReactGA.send({ hitType: 'pageview', page: '/game-feedback/stats', title: 'Stats' });
        } catch {}
    }, []);

    return (
        <div className={styles.Stats}>
            <div className={styles.heading}>
                <h5>Individual</h5>
            </div>

            <hr />

        </div>
    )
}

export default Stats